import { Download, Eye } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import type { ProposalContractViewModel } from './proposal-contract-types';

interface ProposalContractActionsProps {
  contract: ProposalContractViewModel;
  onView?: (contract: ProposalContractViewModel) => void;
  onDownload?: (contract: ProposalContractViewModel) => void;
}

export function ProposalContractActions({
  contract,
  onView,
  onDownload,
}: ProposalContractActionsProps) {
  const showView = Boolean(onView) && contract.canView;
  const showDownload = Boolean(onDownload) && contract.canDownload;

  if (!showView && !showDownload) {
    return (
      <span className="text-xs text-muted-foreground">
        {contract.unavailableReason ?? 'Arquivo indisponível.'}
      </span>
    );
  }

  return (
    <TooltipProvider>
      <div className="flex justify-end gap-1">
        {showView && (
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                variant="ghost"
                className="rounded bg-white px-2 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                onClick={() => onView?.(contract)}
              >
                <Eye className="size-4" />
                <span className="sr-only">Visualizar contrato {contract.name}</span>
              </Button>
            </TooltipTrigger>
            <TooltipContent side="top">Visualizar</TooltipContent>
          </Tooltip>
        )}
        {showDownload && (
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                variant="ghost"
                className="rounded bg-white px-2 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                onClick={() => onDownload?.(contract)}
              >
                <Download className="size-4" />
                <span className="sr-only">Baixar contrato {contract.name}</span>
              </Button>
            </TooltipTrigger>
            <TooltipContent side="top">Baixar</TooltipContent>
          </Tooltip>
        )}
      </div>
    </TooltipProvider>
  );
}
